module.exports = new __parcel__URL__("lock-red-darkmode.35f0d66e.svg").toString();